export default function InstagramBanner() {
  return (
    <div className="flex items-center gap-3 py-8 px-4 justify-center">
      <a
        href="https://www.instagram.com/artisticspaces/"
        target="_blank"
        rel="noopener noreferrer"
        className="flex items-center gap-3 text-gray-800 hover:text-teal-700 transition-colors duration-200"
      >
        <img
          src="/static/images/instagram.png"
          alt="Instagram"
          className="w-6 h-6"
        />
        <span className="text-sm font-medium">artisticspaces on Instagram</span>
      </a>
    </div>
  );
}